export enum CollapsiblePositionBaseValue {
  DepartureTicketInfo = 400,
  Particulars = 500,
  UnitActivity = 1000,
  SagaForms = 1100
}
